module.exports = {
	"id": "QA",
	"name": "Qatar",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.003124,
			"11": 0.006248,
			"12": 0.003124,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.009372,
			"20": 0.003124,
			"21": null,
			"22": 0.03124,
			"23": null,
			"24": 0.006248,
			"25": 0.006248,
			"26": 0.009372,
			"27": 0.003124,
			"28": 0.006248,
			"29": 0.009372,
			"30": 0.009372,
			"31": 0.068728,
			"32": 0.034364,
			"33": 0.021868,
			"34": 0.034364,
			"35": 0.009372,
			"36": 0.021868,
			"37": 0.006248,
			"38": 0.021868,
			"39": 0.021868,
			"40": 0.01562,
			"41": 0.012496,
			"42": 0.009372,
			"43": 0.14058,
			"44": 0.03124,
			"45": 0.049984,
			"46": 0.056232,
			"47": 0.068728,
			"48": 0.024992,
			"49": 0.64042,
			"50": 0.074976,
			"51": 0.4686,
			"52": 0.206184,
			"53": 14.02676,
			"54": 3.773792,
			"55": 0.099968,
			"56": 0.049984,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01562,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.006248,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.006248,
			"32": null,
			"33": 0.006248,
			"34": null,
			"35": 0.006248,
			"36": null,
			"37": 0.006248,
			"38": 0.04686,
			"39": 0.012496,
			"40": 0.012496,
			"41": 0.006248,
			"42": 0.012496,
			"43": 0.043736,
			"44": 0.012496,
			"45": 0.040612,
			"46": 0.043736,
			"47": 0.209308,
			"48": 0.165572,
			"49": 1.661968,
			"50": 0.118712,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.003124
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006248,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.006248,
			"37": 0.081224,
			"38": 0.043736,
			"39": 0.003124,
			"40": 0.243672,
			"41": 0.049984,
			"42": 0.006248,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.012496
		},
		"safari": {
			"0": null,
			"4": 0.003124,
			"5": 0.012496,
			"6": 0.006248,
			"7": 0.021868,
			"8": 0.087472,
			"9": 0.112464,
			"10": 0.684156,
			"3.1": null,
			"3.2": null,
			"5.1": 0.028116,
			"6.1": 0.018744,
			"7.1": 0.021868,
			"9.1": 0.490468
		},
		"ios_saf": {
			"8": 0,
			"10": 5.81441086761,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.156691644879,
			"8.1-8.4": 0.289481174438,
			"9.0-9.2": 0.138101110741,
			"9.3": 2.10692720233
		},
		"android": {
			"3": 0,
			"4": 0.0444008372093,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00555010465116,
			"4.1": 0.160160162791,
			"4.2-4.3": 0.400400406977,
			"4.4": 0.918145883721,
			"4.4.3-4.4.4": 0.926074604651
		},
		"ie": {
			"6": 0.0063073164557,
			"7": 0.0063073164557,
			"8": 0.258599974684,
			"9": 0.343748746835,
			"10": 0.227063392405,
			"11": 3.14419725316,
			"5.5": null
		},
		"op_mob": {
			"0": 0.82935332295,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0230375923042
		},
		"edge": {
			"12": 0.04686,
			"13": 0.268664,
			"14": 0.706024
		},
		"ie_mob": {
			"10": 0.0664357183099,
			"11": 0.27048828169
		},
		"bb": {
			"7": 0.027504,
			"10": null
		},
		"samsung": {
			"0": 3.2661
		},
		"and_uc": {
			"0": 20.66238
		},
		"op_mini": {
			"0": 11.1737330847
		},
		"and_chr": {
			"0": 21.551384
		},
		"and_ff": {
			"0": 0.020628
		}
	},
	"total": 98.332576
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/QA.json
 ** module id = 631
 ** module chunks = 0
 **/